import React, { Component } from 'react'
import { Modal } from '../modal'
import FullScreen from '../fullscreen'
import { videos } from '../../data/data'
import { BROWSER } from '../../browser-detect'
import { Close } from '../icons/index'

class Handler extends Component {
  componentDidMount() {
    if (BROWSER.isExplorer()) {
      BROWSER.handlePolyfill()
      BROWSER.addObjectFindPolyfill()
    }
  }

  handleCloseFullScreen = closeIt => {
    const { pathname } = this.props.location

    if (BROWSER.isExplorer()) {
      BROWSER.addObjectFindPolyfill()
      const filterVideo = (url, videos) => videos.find(video => video.slug === url)
      const trimPath = url => url.replace('/', '')
      const url = trimPath(pathname)
      const video = filterVideo(url, videos)
      const videoIndex = videos.indexOf(video)
      localStorage.setItem('noIntro', true)
      this.props.history.push(`/${videoIndex}`)

    } else {
      const filterVideo = (url, videos) => videos.find(video => video.slug === url)
      const trimPath = url => url.replace('/', '')
      const url = trimPath(pathname)
      const video = filterVideo(url, videos)
      const videoIndex = videos.indexOf(video)
      localStorage.setItem('noIntro', true)
      this.props.history.push(`/${videoIndex}`)
    }
  }
  
  handleIEClick = () => {
    const { pathname } = this.props.location
    localStorage.setItem('noIntro', true)

    if (BROWSER.isExplorer()) {
      BROWSER.addObjectFindPolyfill()
      const filterVideo = (url, videos) => videos.find(video => video.slug === url)
      const trimPath = url => url.replace('/', '')
      const url = trimPath(pathname)
      const video = filterVideo(url, videos)
      const videoIndex = videos.indexOf(video)
      localStorage.setItem('noIntro', true)
      this.props.history.push(`/${videoIndex}`)
    }
  }

  render() {
    const { pathname } = this.props.location
    let filterVideo
    let trimPath

    if (BROWSER.isExplorer()) {
      BROWSER.handlePolyfill()
      BROWSER.addObjectFindPolyfill()
      filterVideo = (url, videos) => videos.find(video => video.slug === url)
      trimPath = url => url.replace('/', '')
    } else {
      filterVideo = (url, videos) => videos.find(video => video.slug === url)
      trimPath = url => url.replace('/', '')
    }

    const url = trimPath(pathname)
    const video = filterVideo(url, videos)
    const videoIndex = videos.indexOf(video)

    if (BROWSER.isExplorer()) {
      const videoStyle = {
        height: '100%',
        width: '100%'
      }
      return (
        <div>
          <button onClick={this.handleIEClick}>
            <Close />
          </button>
          <video className="ie_video" style={videoStyle} controls>
            <source src={video.url} type="video/mp4" />
          </video>
        </div>
      )
    } else {
      return (
        <FullVideo closeFullScreen={this.handleCloseFullScreen} videos={videos} videoIndex={videoIndex} video={video} />
      )
    }
  }
}
export default Handler

const FullVideo = props => (
  <Modal>
    <FullScreen
      playing={true}
      closeFullScreen={props.closeFullScreen}
      videos={props.videos}
      videoIndex={props.videoIndex}
      video={props.video}
    />
  </Modal>
)



// WEBPACK FOOTER //
// ./src/components/handler/index.js